export default "__VITE_ASSET__MermKXiU__"